import React from "react";
import Button from "../utils/Button";
import useShopStore from "../store/useShopStore";

export default function EmptyCartButton() {
  const { clearCart } = useShopStore((state) => state);

  const clearCartHandler = (e) => {
    e.preventDefault();
    clearCart();
  };

  return <Button onClick={clearCartHandler}>Clear Cart</Button>;
}
